import { render, staticRenderFns } from "./Browser.vue?vue&type=template&id=3cfac426"
import script from "./Browser.vue?vue&type=script&lang=js"
export * from "./Browser.vue?vue&type=script&lang=js"
import style0 from "./Browser.vue?vue&type=style&index=0&id=3cfac426&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports